import { injectIntl } from 'gatsby-plugin-locale';

const Redirect = () => {
	return null;
};

export default injectIntl(Redirect);
